module.exports = __webpack_public_path__ + "static/media/6@3x.2486f32e.png";